import { render, staticRenderFns } from "./MatterDocumentList.vue?vue&type=template&id=345a67aa&"
import script from "./MatterDocumentList.vue?vue&type=script&lang=js&"
export * from "./MatterDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./MatterDocumentList.vue?vue&type=style&index=0&id=345a67aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports